import { FC } from "react";
import { Control } from "react-hook-form";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { TagPicker } from "./TagPicker";
import { IChangelogRecord } from "../../../interfaces";
import "./style.css";

interface Props {
  control: Control<IChangelogRecord>;
  onAddChangelogRecordClick: () => void;
  onClearChangelogRecordFormClick: () => void;
}

export const ChangelogForm: FC<Props> = ({
  control,
  onAddChangelogRecordClick,
  onClearChangelogRecordFormClick,
}) => {
  return (
    <div className="changelog-form">
      <p>Add changelog record:</p>
      <Input name="id" label="Id:" control={control} />
      <Input
        name="description"
        label="Description:"
        control={control}
        rows={5}
        multiline
      />
      <TagPicker control={control} />
      <Button onClick={onAddChangelogRecordClick}>Add changelog record</Button>
      <Button version="secondary" onClick={onClearChangelogRecordFormClick}>
        Clear changelog record
      </Button>
    </div>
  );
};
